module.exports = __webpack_public_path__ + "img/pr-4.7bc1cb9c.png";